import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {TaakTipAantal, TaakTipAantalDto} from './taak-tip-aantal';

@Injectable({
  providedIn: 'root'
})
export class TipService {
  private http = inject(HttpClient);

  getTaakTipAantallen(clientId: string): Observable<Array<TaakTipAantal>> {
    const params = new HttpParams()
      .set('clientId', clientId);
    return this.http.get<Array<TaakTipAantalDto>>(`${environment.apiUrl}/tips/aantal`, {params})
      .pipe(map(dtos => dtos.map(dto => TaakTipAantal.deserialize(dto))));
  }
}
